import React from 'react';
import { motion } from 'framer-motion';
import CTAButton from '../CTAButton';
import { Briefcase, Building2, Cpu, Factory, HeartPulse, Landmark, Plane, ShoppingCart, Truck, Wrench, Shield, Database, GraduationCap } from 'lucide-react';

const getIcon = (title) => {
    const t = title.toLowerCase();
    if (t.includes('it') || t.includes('tech') || t.includes('software') || t.includes('digital')) return <Cpu strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('health') || t.includes('medical') || t.includes('pharma') || t.includes('life science')) return <HeartPulse strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('manufactur') || t.includes('industr') || t.includes('engineering')) return <Factory strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('financ') || t.includes('bank') || t.includes('fintech') || t.includes('accounting')) return <Landmark strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('retail') || t.includes('ecommerce') || t.includes('fmcg') || t.includes('consumer')) return <ShoppingCart strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('logistic') || t.includes('supply') || t.includes('transport')) return <Truck strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('aero') || t.includes('aviat') || t.includes('space')) return <Plane strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('construct') || t.includes('real estate') || t.includes('infrastructure')) return <Building2 strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('auto') || t.includes('motor')) return <Wrench strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('defen') || t.includes('secur')) return <Shield strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('data') || t.includes('analy')) return <Database strokeWidth={1.5} className="w-8 h-8" />;
    if (t.includes('educat') || t.includes('learn') || t.includes('edtech')) return <GraduationCap strokeWidth={1.5} className="w-8 h-8" />;
    return <Briefcase strokeWidth={1.5} className="w-8 h-8" />;
}

const IndustryExpertise = ({ data, title, desc, onCtaClick }) => {
    return (
        <section className="py-24 bg-white relative overflow-hidden">
            {/* Soft background texture for the section */}
            <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
            
            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-3xl mb-5">
                    <h2 className="text-4xl md:text-5xl font-bold text-slate-900 syne mb-6">
                        {title || <>Industry-Focused <span className="text-blue-600">Expertise</span></>}
                    </h2>
                    <p className="text-slate-500">
                        {desc || "We deeply understand industry-specific workforce demands."}
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {data.map((item, i) => (
                        <motion.div 
                            whileHover={{ y: -10 }} 
                            key={i} 
                            className="relative overflow-hidden p-3 bg-blue-50/30 rounded-[2rem] border border-blue-100/50 group hover:bg-blue-600 transition-all duration-500 shadow-sm hover:shadow-xl hover:shadow-blue-600/20"
                        >
                            {/* Card Texture Layer */}
                            <div className="absolute inset-0 opacity-10 group-hover:opacity-20 transition-opacity duration-500" 
                                style={{ 
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='1' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
                                    backgroundSize: '16px 16px' 
                                }} 
                            />
                            
                            {/* Gradient Overlay on Hover */}
                            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-blue-700/0 group-hover:from-white/10 group-hover:to-transparent transition-all duration-500" />
                            
                            <div className="relative z-10 flex flex-col h-full">
                                <div className="w-16 h-16 rounded-2xl bg-white border border-blue-100 shadow-sm flex items-center justify-center text-blue-600 mb-6 group-hover:scale-110 group-hover:bg-white/10 group-hover:border-white/20 group-hover:text-white group-hover:shadow-lg transition-all duration-500">
                                    {getIcon(item.title)}
                                </div>
                                <h4 className="text-xl font-bold text-slate-900 group-hover:text-white mb-4 transition-colors duration-500">{item.title}</h4>
                                <p className="text-sm text-slate-600 group-hover:text-blue-50 transition-colors duration-500 leading-relaxed">{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
                {onCtaClick && (
                    <div className="mt-16 flex justify-center">
                        <CTAButton text="Connect With Industry Specialists" onClick={onCtaClick} />
                    </div>
                )}
            </div>
        </section>
    );
};
export default IndustryExpertise;